import { createBrowserRouter, Navigate } from "react-router-dom";
import MainLayout from "./Layouts/MainLayout";
import IndustryLayout from "./Layouts/IndustryLayout";
import BlogLayout from "./Layouts/BlogLayout";
import AppLayout from "./Layouts/AppLayout";
// --------------------------------------------------------------
import HomePage from "./Pages/HomePage/HomePage";
import AboutUsPage from "./Pages/AboutUsPage/AboutUsPage";
import ContactUsPage from "./Pages/ContactUsPage/ContactUsPage";
import HR_Portal from "./Pages/Portal/HR_Portal";
import Self_Verification from "./Pages/Portal/Self_Verification";
import Offer_Portal from "./Pages/Portal/Offer_Portal";
import GR_Portal from "./Pages/Portal/GR_Portal";
import AllIndustries from "./Pages/Medical_Sector/AllIndustries";
import Banking from "./Pages/Medical_Sector/Banking";
import MedicalSector from "./Pages/Medical_Sector/Medical_Sector";
import Games from "./Pages/Medical_Sector/Games";
import Education from "./Pages/Medical_Sector/Education";
import Manufacture from "./Pages/Medical_Sector/Manufacture";
import ItPage from "./Pages/ItPage/ItPage";
import GigWorkers from "./Pages/Medical_Sector/Gig_workers";
import ECommerce from "./Pages/Medical_Sector/E_Commerce";
import Logistics from "./Pages/Medical_Sector/Logistic";
import ConsumerGoods from "./Pages/Medical_Sector/Consumer_Goods";
import FMCG from "./Pages/Medical_Sector/FMCG";
import Travel from "./Pages/Medical_Sector/Travel";
import Govt_API from "./Pages/Govt_API/Govt_API";
// ---------------------------------------------------------------
import BlogsPage from "./Pages/BlogsPage/BlogsPage";
import SingleBlogPage from "./Pages/SingleBlogPage/SingleBlogPage";
import SignUp from "./Pages/GetStartedForm/SignUp";
import CandidateDetailsForm from "./Components/CandidateDetailsForm/CandidateDetailsForm";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import SuccessCard from "./Components/CandidateDetailsForm/SuccessCard/SuccessCard";
import ContactWithSales from "./Pages/ContactWithSales/ContactWithSales";
import NotFound from "./Pages/404/NotFound";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import RefundPolicy from "./Pages/RefundPolicy/RefundPolicy";
// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <AppLayout />, // Global wrapper
//     children: [
//       {
//         path: "/",
//         element: <MainLayout />,
//         children: [
//           { index: true, element: <HomePage /> },
//           { path: "about-us", element: <AboutUsPage /> },
//           { path: "connect-with-sales", element: <ContactWithSales /> },
//           { path: "contact-us", element: <ContactUsPage /> },
//           { path: "hr-portal", element: <HR_Portal /> },
//           { path: "self-verification", element: <Self_Verification /> },
//           { path: "offer-portal", element: <Offer_Portal /> },
//           { path: "grievance-portal", element: <GR_Portal /> },
//           { path: "govt-api", element: <Govt_API /> },
//           { path: "sign-up", element: <SignUp /> },
//           { path: "connect-with-sales", element: <ContactWithSales /> },
//                 {
//         path: "industries",
//         element: <IndustryLayout />,
//         children: [
//           { index: true, element: <AllIndustries /> },
//           { path: "banking", element: <Banking /> },
//           { path: "healthcare", element: <MedicalSector /> },
//           { path: "online-gaming", element: <Games /> },
//           { path: "education", element: <Education /> },
//           { path: "manufacturing", element: <Manufacture /> },
//           { path: "it-ites", element: <ItPage /> },
//           { path: "gig-workers", element: <GigWorkers /> },
//           { path: "ecommerce", element: <ECommerce /> },
//           { path: "logistics", element: <Logistics /> },
//           { path: "consumer-goods", element: <ConsumerGoods /> },
//           { path: "fmcg", element: <FMCG /> },
//           { path: "travel", element: <Travel /> },
//           // { path: "*", element: <NotFound /> },
//         ],
//       },
//       {
//         path: "/blogs",
//         element: <BlogLayout />,
//         children: [
//           { index: true, element: <BlogsPage /> },
//           { path: ":slug", element: <SingleBlogPage /> },
//           // { path: "*", element: <NotFound /> },
//         ],
//       },

//           {
//             element: <ProtectedRoute />,
//             children: [
//               { path: "candidate-details", element: <CandidateDetailsForm /> },
//               { path: "submission-success", element: <SuccessCard /> },
//             ],
//           },

//           // { path: "*", element: <NotFound /> },
//         ],
//       },

//       { path: "*", element: <NotFound /> }
//     ],
//   },
// ]);

// export default router;

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <AppLayout />, // Global wrapper
      children: [
        {
          path: "/",
          element: <MainLayout />,
          children: [
            { index: true, element: <HomePage /> },
            { path: "about-us", element: <AboutUsPage /> },
            // { path: "connect-with-sales", element: <ContactWithSales /> },
            { path: "contact-us", element: <ContactWithSales /> },
            { path: "product/hr-portal", element: <HR_Portal /> },
            { path: "self-verification", element: <Self_Verification /> },
            { path: "offer-portal", element: <Offer_Portal /> },
            { path: "grievance-portal", element: <GR_Portal /> },
            { path: "govt-api", element: <Govt_API /> },
            { path: "sign-up", element: <SignUp /> },
            { path: "privacy-policy", element: <PrivacyPolicy /> },
            { path: "refund-policy", element: <RefundPolicy /> },

            {
              element: <ProtectedRoute />,
              children: [
                {
                  path: "candidate-details",
                  element: <CandidateDetailsForm />,
                },
                { path: "submission-success", element: <SuccessCard /> },
              ],
            },
          ],
        },

        {
          path: "industries",
          element: <IndustryLayout />,
          children: [
            { index: true, element: <AllIndustries /> },
            { path: "banking", element: <Banking /> },
            { path: "healthcare", element: <MedicalSector /> },
            { path: "online-gaming", element: <Games /> },
            { path: "education", element: <Education /> },
            { path: "manufacturing", element: <Manufacture /> },
            { path: "it-ites", element: <ItPage /> },
            { path: "gig-workers", element: <GigWorkers /> },
            { path: "ecommerce", element: <ECommerce /> },
            { path: "logistics", element: <Logistics /> },
            { path: "consumer-goods", element: <ConsumerGoods /> },
            { path: "fmcg-fmcd", element: <FMCG /> },
            { path: "travel", element: <Travel /> },
            // { path: "*", element: <NotFound /> },
          ],
        },
        {
          path: "blogs",
          element: <BlogLayout />,
          children: [
            { index: true, element: <BlogsPage /> },
            { path: ":slug", element: <SingleBlogPage /> },
            //  { path: "*", element: <NotFound /> },
          ],
        },
        {
          path: "hr_portal/*",
          element: <Navigate to="/hr_portal/" replace />,
        },

        { path: "*", element: <NotFound /> },
      ],
    },
  ]
  // {
  //   basename: "/", // basename
  // }
);

export default router;
